import { useIsMutating } from "@tanstack/react-query";

export const useIsCreatingResource = ({
  resource,
  locale,
}: {
  resource: string;
  locale: string;
}) => {
  const creatingCount = useIsMutating({
    mutationKey: [resource, "createOne"],
    predicate: (mutation) => {
      return mutation.state.variables.locale === locale;
    },
  });

  return creatingCount > 0;
};
